<template>
    <div class="features-area hidden-xs" id="funcionalidades">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-title text-center">
                        <h1>Algumas <span>Funcionalidades</span></h1>
                        <p>Veja algumas das funcionalidades que oferecemos para auxílio na gestão da sua empresa.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-7 col-lg-offset-5 col-md-9 col-md-offset-3 col-sm-12 col-sm-offset-0 feature-wrapper">
                    <div class="single-item">
                        <div class="single-item-icon">
                            <i class="fa icon-font icon-moneybag"></i>
                        </div>
                        <div class="single-item-text">
                            <h4>Controle Financeiro</h4>
                            Controle financeiro empresarial que conta com inúmeros recursos e rotinas que vão lhe auxiliar no dia-a-dia de sua empresa para realizar a gestão financeira, saiba mais!
                        </div>
                    </div>
                    <div class="single-item">
                        <div class="single-item-icon">
                            <i class="fa icon-cube"></i>
                        </div>
                        <div class="single-item-text">
                            <h4>Controle de Estoque</h4>
                            <p>Controle de estoque completo para sua empresa. Você pode gerenciar produtos, vendas, compras, movimentações, transferências, relatórios, fornecedores e muito mais, saiba mais!</p>
                        </div>
                    </div>
                    <div class="single-item">
                        <div class="single-item-icon">
                            <i class="fa fa-files-o"></i>
                        </div>
                        <div class="single-item-text">
                            <h4>Orçamentos e Vendas</h4>
                            <p>Controle seus orçamentos, vendas e ordens de serviços sem complicação. Nosso software de gestão empresarial é bem completo para gerenciar suas vendas de produtos e serviços.</p>
                        </div>
                    </div>
                    <div class="single-item">
                        <div class="single-item-icon">
                            <i class="fa icon-sync"></i>
                        </div>
                        <div class="single-item-text">
                            <h4>Emissão de Notas</h4>
                            <p>Com o Software Emissor de Nota Fiscal Online do você pode emitir notas fiscais eletrônicas de produtos e serviços com rapidez e facilidade.</p>
                        </div>
                    </div>
                    <div class="single-item">
                        <div class="single-item-icon">
                            <i class="fa fa-barcode"></i>
                        </div>
                        <div class="single-item-text">
                            <h4>Emissão de Boletos</h4>
                            <p>Controle todos os boletos emitidos por sua empresa e acompanhe cada pagamento feito por seu cliente através desta ferramenta, saiba mais!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>